"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GiftCardAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async createEmptyGiftCard(card) {
        return await this.client.post(`/gift-cards`, card);
    }
    async loadGiftCard({ giftCardId, ...params }) {
        return await this.client.post(`/gift-cards/${giftCardId}/credit`, params);
    }
    async estimateCardTotal(locationId, amount) {
        return await this.client.post(`/gift-cards/amounts`, {
            locationId,
            amount,
        });
    }
    async fetchOverview(giftCardNumber) {
        return await this.client.get(`/gift-cards/overview`, {
            number: giftCardNumber,
        });
    }
}
exports.default = GiftCardAPI;
//# sourceMappingURL=index.js.map